import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { DiagnoseTemplateList, DiagnoseTemplate } from '../business-entities/diagnose-template-modal';

@Injectable({
    providedIn: 'root'
})

export class DiagnoseTemplateDataService {
    constructor(private dataProvider: DataService) {
    }

    async getDiagnoseTemplateList(model:any): Promise<GenericResponse<Array<DiagnoseTemplateList>>> {
        return this.dataProvider.Post<GenericResponse<Array<DiagnoseTemplateList>>>(Urls.GetDiagnoseTemplates,model)
        .toPromise();
    }

    addDiagnoseTemplate(model:any) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDiagnoseTemplate, model).toPromise();
    }

    async getDiagnoseTemplateById(Id: number): Promise<GenericResponse<DiagnoseTemplate>> {
        return this.dataProvider.Get<GenericResponse<DiagnoseTemplate>>
        (Urls.GetDiagnoseTemplateById, Id).toPromise();
    }
    editDiagnoseTemplate(model:any): Promise<any> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditDiagnoseTemplate, model).toPromise();
    }

    deleteDiagnoseTemplate(Id:number){
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteDiagnoseTemplate,Id).toPromise();
    }
}
